import React from "react";

const ClassLoading = () => {
  return (
    <div className="class-container">
      <div className="class-container-section">
        <div className="content-section">
          {/* Video Section Skeleton */}
          <div style={{ flex: 2 }}>
            <div className="skeleton skeleton-video"></div>
            <div className="skeleton skeleton-video-info"></div>
            <div className="skeleton skeleton-video-instructor"></div>
          </div>
          
          {/* Lesson Section Skeleton */}
          <div style={{ flex: 1 }}>
            {[...Array(5)].map((_, i) => (
              <div key={i} className="skeleton skeleton-lesson-item"></div>
            ))}
          </div>
        </div>
        
        <div className="content-menu-section">
          {/* Menu Tab Skeleton */}
          <div style={{ flex: 1 }}>
            <div className="skeleton skeleton-tab"></div>
          </div>
          
          {/* Class Progress Skeleton */}
          <div style={{ flex: 1 }}>
            <div className="skeleton skeleton-progress"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClassLoading;